if (!customElements.get("m-video-community-slider")) {
  class MVideoCommunitySlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.items = parseInt(this.dataset.items) || 3;
      this.showNavigation = this.dataset.showNavigation === "true";
      this.slideContainer = this.querySelector(".m-video-community__slider-wrapper");

      this.initSlider();
      this.initSoundToggles();
    }

    initSlider() {
      if (!this.slideContainer) return;
      const slidesCount = this.slideContainer.querySelector(".swiper-wrapper").childElementCount;

      this.slider = new MinimogLibs.Swiper(this.slideContainer, {
        slidesPerView: 1.2,
        spaceBetween: 16,
        threshold: 2,
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1280: {
            slidesPerView: this.items,
            spaceBetween: 24,
          },
        },
        on: {
          init: (swiper) => this.updateNavState(swiper),
          slideChange: (swiper) => this.updateNavState(swiper),
          breakpoint: (swiper) => this.updateNavState(swiper),
        },
      });

      const prevButton = this.querySelector(".m-video-community__nav-prev");
      const nextButton = this.querySelector(".m-video-community__nav-next");

      if (this.slider && this.showNavigation) {
        prevButton && prevButton.addEventListener("click", () => this.slider.slidePrev());
        nextButton && nextButton.addEventListener("click", () => this.slider.slideNext());
      }

      if (slidesCount <= this.items) {
        this.slideContainer.classList.add("m-video-community__slider--static");
      }
    }

    updateNavState(swiper) {
      const prevButton = this.querySelector(".m-video-community__nav-prev");
      const nextButton = this.querySelector(".m-video-community__nav-next");
      if (!prevButton || !nextButton) return;

      prevButton.toggleAttribute("disabled", swiper.isBeginning);
      nextButton.toggleAttribute("disabled", swiper.isEnd);
    }

    initSoundToggles() {
      this.querySelectorAll("[data-sound-toggle]").forEach((button) => {
        button.addEventListener("click", () => {
          const card = button.closest(".m-video-community__card");
          const video = card && card.querySelector("video");
          if (!video) return;

          const unmute = video.muted;

          // Only one card with sound at a time
          this.querySelectorAll("video").forEach((v) => {
            v.muted = true;
          });
          this.querySelectorAll("[data-sound-toggle]").forEach((b) => {
            b.classList.remove("is-unmuted");
          });

          if (unmute) {
            video.muted = false;
            button.classList.add("is-unmuted");
          }
        });
      });
    }
  }

  customElements.define("m-video-community-slider", MVideoCommunitySlider);
}
